import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  APP_LOCK_DOMAIN,
  appLockApi,
  type AppLockSettings,
} from "./appLockApi";
import { sendMessage } from "utils/webview";

export const APP_LOCK_QUERY_KEY = [APP_LOCK_DOMAIN, "settings"] as const;

export function useDisableAppLock() {
  const queryClient = useQueryClient();
  return useMutation({
    // Disable must also remove PIN on the server
    mutationFn: () => appLockApi.removePin(),
    onSuccess: (data: AppLockSettings) => {
      const prev =
        queryClient.getQueryData<AppLockSettings>(APP_LOCK_QUERY_KEY);
      if (!prev || prev.isEnabled !== data.isEnabled) {
        try {
          sendMessage(
            JSON.stringify({
              event: "set_app_lock",
              params: { isEnabled: data.isEnabled ? "true" : "false" },
            })
          );
        } catch {}
      }
      queryClient.setQueryData(APP_LOCK_QUERY_KEY, data);
    },
  });
}

export function useSetAppLockPin() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      pinHash,
      isEnable = true,
    }: {
      pinHash: string;
      isEnable?: boolean;
    }) => appLockApi.setPin(pinHash, isEnable),
    onSuccess: (data: AppLockSettings) => {
      const prev =
        queryClient.getQueryData<AppLockSettings>(APP_LOCK_QUERY_KEY);
      if (!prev || prev.isEnabled !== data.isEnabled) {
        try {
          sendMessage(
            JSON.stringify({
              event: "set_app_lock",
              params: { isEnabled: data.isEnabled ? "true" : "false" },
            })
          );
        } catch {}
      }
      queryClient.setQueryData(APP_LOCK_QUERY_KEY, data);
    },
  });
}

export function useUpdateBiometricEnabled() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (isBiometricEnabled: boolean) =>
      appLockApi.updateSettings({ isBiometricEnabled: isBiometricEnabled }),
    onSuccess: (data: AppLockSettings) => {
      const prev =
        queryClient.getQueryData<AppLockSettings>(APP_LOCK_QUERY_KEY);
      if (!prev || prev.isEnabled !== data.isEnabled) {
        try {
          sendMessage(
            JSON.stringify({
              event: "set_app_lock",
              params: { isEnabled: data.isEnabled ? "true" : "false" },
            })
          );
        } catch {}
      }
      queryClient.setQueryData(APP_LOCK_QUERY_KEY, data);
    },
  });
}
